/* eslint-disable @typescript-eslint/no-explicit-any, react/no-find-dom-node */
import * as React from 'react';
import { findDOMNode } from 'react-dom';

interface IElementInViewportProps {
  onChange(isVisible: boolean): void;
  viewPercent?: number;
}

interface IElementInViewportState {
  isVisible: boolean;
}

export class ElementInViewport extends React.Component<IElementInViewportProps, IElementInViewportState> {
  public constructor(props: IElementInViewportProps) {
    super(props);

    this.state = {
      isVisible: false,
    };
  }

  public UNSAFE_componentWillUpdate(nextProps: IElementInViewportProps, nextState: IElementInViewportState) {
    if (this.state.isVisible !== nextState.isVisible) {
      this.props.onChange(nextState.isVisible);
    }
  }

  public componentDidMount() {
    document.addEventListener('resize', this.handleResize);
    document.addEventListener('scroll', this.handleScroll);

    this.setVisibility();
  }

  public componentWillUnmount() {
    document.removeEventListener('resize', this.handleResize);
    document.removeEventListener('scroll', this.handleScroll);
  }

  public render() {
    return this.props.children as JSX.Element;
  }

  private setVisibility() {
    if (this.state.isVisible) {
      return;
    }

    const component = findDOMNode(this) as HTMLElement;

    if (!component) {
      return;
    }

    const viewPercent = this.props.viewPercent || 1;
    const { top, height } = component.getBoundingClientRect();
    const offset = Math.max(window.innerHeight - height * viewPercent, 0);

    const isVisible = top <= offset && top >= -height * viewPercent;

    if (isVisible !== this.state.isVisible) {
      this.setState({
        isVisible,
      });
    }
  }

  private handleResize = () => {
    this.setVisibility();
  };

  private handleScroll = () => {
    this.setVisibility();
  };
}
